export default "__VITE_ASSET__3388855a__"